export const createReferenceDate = (time: string, date = new Date()): Date =>
  new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    parseInt(time.split(':')[0], 10),
    parseInt(time.split(':')[1], 10),
    parseInt(time.split(':')[2], 10),
  );
